export const toPhoneWithoutInternationalCode = (phone: string): string =>
  phone.replace(/\D+/g, '').slice(-10);

export const toFriendlyPhoneFormat = (phone: string | null): string | null => {
  if (!phone) {
    return phone;
  }
  return toPhoneWithoutInternationalCode(phone).replace(
    /^(\d{3})(\d{3})(\d{2})(\d{2})$/,
    '+7 $1 $2-$3-$4',
  );
};

export const toSimplePhoneFormat = (phone: string | null): string | null => {
  if (!phone) {
    return phone;
  }
  return `+7${toPhoneWithoutInternationalCode(phone)}`;
};
